import Vue from 'vue';
import ContractService from '@/services/contract.service';

export const contracts = {
  namespaced: true,
  state: {
    contracts: [],
  },
  actions: {
    get({ commit }) {
      ContractService.get().then(
        contracts => {
          commit('getSuccess', contracts);
        },
        () => {
          commit('getFailure');
        },
      );
    },
    resetState({ commit }) {
      commit('resetState');
    },
  },
  mutations: {
    getSuccess(state, contracts) {
      Vue.set(state, 'contracts', contracts);
    },
    getFailure(state) {
      Vue.set(state, 'contracts', []);
    },
    resetState(state) {
      state.contracts = [];
    },
  },
  getters: {},
};
